import script from "./RunTestsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RunTestsDialog.vue?vue&type=script&setup=true&lang=js"

import "./RunTestsDialog.vue?vue&type=style&index=0&id=5932ada8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5932ada8"]])

export default __exports__